// extracted by mini-css-extract-plugin
export default {"circle":"circle--mp-fbH1i","faq":"faq--mp-negWc","details":"details--mp-wYAOg"};